import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ShopByCategory from "./pages/ShopByCategory";
import Registration from "./components/Forms/Registration";
import Compare from "./pages/Compare";
import Loader from "./components/Loader/Loader";
import { useLoading } from "./hooks/useLoading";
import AllOffers from "./pages/AllOffers";
import Profile from "./pages/Profile";
import Layout from "./pages/Layout";
import Authenticate from "./pages/Authenticate";
import ProtectedRoute from "./routes/ProtectedRoute";
import RequireAuth from "./routes/RequireAuth";
import ApnamartWallet from "./pages/ApnamartWallet";
import GiftStore from "./pages/GiftStore";
import EditProfile from "./components/Forms/EditProfile";
import AboutUs from "./pages/AboutUs";
import HelpUs from "./pages/HelpUs";
import SellerRegistration from "./pages/SellerRegistration";
import DashboarForSeller from "./pages/DashboarForSeller";

function App() {
  // Get the loading state
  const { loading } = useLoading();
  return !loading ? (
    <Loader message="Loading, Please wait..." />
  ) : (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="shopbycategory" element={<ShopByCategory />} />
          <Route path="compare" element={<Compare />} />
          <Route path="/alloffers" element={<AllOffers />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/shop/:productList" element={<Shop />} />
          <Route path="/gifting" element={<GiftStore />} />
          <Route path="help" element={<HelpUs />} />
          <Route path="seller" element={<SellerRegistration />} />
          <Route path="aboutus" element={<AboutUs />} />

          <Route path="seller/dashboard" element={<DashboarForSeller />} />

          {/* protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="login" element={<Authenticate />} />
          </Route>

          {/* private routes */}
          <Route element={<RequireAuth />}>
            <Route path="cart" element={<Cart />} />
            <Route path="mylist" element={<Shop />} />

            <Route path="/edit" element={<EditProfile />} />
            <Route path="/profile" element={<Profile />} />

            <Route path="/wallet" element={<ApnamartWallet />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
